import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Full-screen overlay shown while a story is being fetched, using the same
// animated APNG splash used on the app's launch screen.
export default function StoryLoadingOverlay() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        background: '#FACF9F',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL || ''}/assets/founders-loading.png`}
        alt=""
        sx={{ width: { xs: 200, sm: 260 }, height: { xs: 200, sm: 260 }, objectFit: 'contain' }}
      />
      <Typography
        sx={{
          fontFamily: '"Raleway", sans-serif',
          fontSize: 13,
          color: '#8a7468',
        }}
      >
        Getting your stories ready...
      </Typography>
    </Box>
  );
}
